import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApVendor } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-unlink-ap-vendors-modal',
  templateUrl: './unlink-ap-vendors-modal.component.html',
  styleUrl: './unlink-ap-vendors-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UnlinkApVendorsModalComponent implements OnInit {
  constructor(
    private ActiveModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() CompanyId?: number;
  @Input() VendorId?: number;
  @Input() ExemptVendorId?: number;
  @Input() ClientRegisteredVendorId?: number;
  SuppliedQueryData?: GenericObject;
  SelectedApVendorIds = new Set<number>();

  close() {
    this.ActiveModal.dismiss();
  }

  continue() {
    const ApVendorsToUnlink = Array.from(this.SelectedApVendorIds).map(
      (ApVendorId) =>
        new ApVendor({
          id: ApVendorId,
          VendorId: null,
          ExemptVendorId: null,
          ClientRegisteredVendorId: null,
          syncAt: null
        })
    );

    this.ActiveModal.close(ApVendorsToUnlink);
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client id.', {
        returnError: true
      });
    }

    if (
      !this.VendorId &&
      !this.ClientRegisteredVendorId &&
      !this.ExemptVendorId
    ) {
      throw this.ToastService.addErrorToast('Error', 'Missing vendor id.', {
        returnError: true
      });
    }

    const countOfVendorIds = [
      !!this.VendorId,
      !!this.ExemptVendorId,
      !!this.ClientRegisteredVendorId
    ].reduce((accum, currValue) => {
      return currValue ? accum + 1 : accum;
    }, 0);

    if (countOfVendorIds > 1) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Multiple vendor ids found.',
        { returnError: true }
      );
    }

    this.SuppliedQueryData = {
      ApConfig: {
        options: { required: true },
        CompanyId: this.CompanyId
      }
    };

    if (this.VendorId) {
      Object.assign(this.SuppliedQueryData, { VendorId: this.VendorId });
    }

    if (this.ExemptVendorId) {
      Object.assign(this.SuppliedQueryData, {
        ExemptVendorId: this.ExemptVendorId
      });
    }

    if (this.ClientRegisteredVendorId) {
      Object.assign(this.SuppliedQueryData, {
        ClientRegisteredVendorId: this.ClientRegisteredVendorId
      });
    }
  }
}
